import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Internet({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Internet</title>
      <path
        d="M4 15L20 15"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 9L20 9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0004 20.818L11.4647 21.3429C11.6058 21.4869 11.7988 21.568 12.0004 21.568C12.2019 21.568 12.395 21.4869 12.5361 21.3429L12.0004 20.818ZM12.0004 3.18164L12.5361 2.65672C12.395 2.51276 12.2019 2.43164 12.0004 2.43164C11.7988 2.43164 11.6058 2.51276 11.4647 2.65672L12.0004 3.18164ZM14.8504 11.9998C14.8504 15.2289 13.5598 18.155 11.4647 20.2931L12.5361 21.3429C14.8948 18.9358 16.3504 15.6371 16.3504 11.9998H14.8504ZM11.4647 3.70657C13.5598 5.84463 14.8504 8.77076 14.8504 11.9998H16.3504C16.3504 8.36256 14.8948 5.06379 12.5361 2.65672L11.4647 3.70657ZM9.15039 11.9998C9.15039 8.77076 10.4409 5.84463 12.5361 3.70657L11.4647 2.65672C9.10597 5.06379 7.65039 8.36256 7.65039 11.9998H9.15039ZM12.5361 20.2931C10.4409 18.155 9.15039 15.2289 9.15039 11.9998H7.65039C7.65039 15.6371 9.10597 18.9358 11.4647 21.3429L12.5361 20.2931Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
